import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

/**
 * Shown when an authenticated user opens a route their group cannot access.
 * Keeps the session intact (no bounce to /login).
 */
export const AccessDeniedPage: React.FC<{
  path?: string;
  homePath?: string;
}> = ({ path, homePath = '/' }) => {
  return (
    <div className="p-6">
      <div className="mx-auto max-w-lg rounded-xl border border-amber-200 bg-amber-50/80 px-6 py-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-800">
          <ShieldOff className="h-6 w-6" aria-hidden />
        </div>
        <h1 className="font-display text-xl text-secondary-900">Access denied</h1>
        <p className="mt-2 text-sm text-secondary-700">
          Your account does not have permission to open
          {path ? (
            <>
              {' '}
              <span className="font-mono text-secondary-900">{path}</span>
            </>
          ) : (
            ' this page'
          )}
          . You are still signed in.
        </p>
        <p className="mt-1 text-sm text-secondary-600">
          Ask an administrator to grant access under Permissions → People / What groups can do.
        </p>
        <Link
          to={homePath}
          className="mt-6 inline-flex items-center justify-center rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
};
